<template>
  <div class="detail">
    <h1>争议内容</h1>
    <div class="content">
      <div class="list">
        <h2>争议基本信息</h2>
        <div class="base">
          <div class="item">最晚回复时间：{{data.sellerDueDateTime}}</div>
          <div class="item">争议金额：{{data.disputeCode}}{{data.disputeValue}}</div>
          <div class="item">付款人邮箱：{{data.buyerEmail}}</div>
        </div>
        <div class="address">地址：{{data.buyerCountry}}{{data.buyerAddress}}</div>
      </div>
      <div class="list">
        <h2>争议内容</h2>
        <el-timeline style="padding-top:20px;width:70%;height:400px;overflow:auto">

          <el-timeline-item :timestamp="item.posted_by" placement="top" :color="item.posted_by=='BUYER'?'#67C23A':'#F56C6C'" v-for="(item,index) in data.disputeMessages" :key="index">
            <el-card>
                <div class="con">
                    {{item.content}}
                </div>
                <p class="time">提交时间：{{item.time_posted}}</p>
            </el-card>
          </el-timeline-item>
        </el-timeline>
        <div class="submit">
          <el-input type="textarea" v-model="Msg"></el-input>
          <el-button type="success" @click="submit()">回复</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {GetDisputeDetail,AddMsg} from '@/utils/api';
export default {
  data() {
    return {
      Msg:"",
      data:{
        disputeMessages:[]
      }
    }
  },
  methods: {
    initData(){
      GetDisputeDetail({
        disputeId:this.$route.query.disputeId
      }).then(res=>{
        if(res){
          this.data = res;
        }
      })
    },
    submit(){
      if(this.Msg==''){
        this.$message.error('回复内容不能为空');
        return;
      }

      AddMsg({
        Msg:this.Msg,
        DisputeId:this.$route.query.disputeId
      }).then(res=>{
        if(res){
          this.$message.success('回复成功');
          this.initData();
        }
      })

    }
  },
  created(){
    this.initData();
  }
};
</script>

<style lang="less" scoped>
.detail {
  h1 {
    font-size: 20px;
    font-weight: bold;
    padding: 20px 0;
  }
  .content {
    padding-left: 10px;
    .list {
      padding-top: 30px;
      h2 {
        font-size: 18px;
        font-weight: bold;
        position: relative;
        padding-left: 20px;
        padding-bottom: 20px;
        &::before {
          content: "";
          width: 8px;
          height: 8px;
          border-radius: 8px;
          display: block;
          position: absolute;
          left: 0;
          top: 6px;
          background: #000;
        }
      }
      .base {
        display: flex;
        display: -webkit-flex;
      }
      .address {
        padding: 10px 20px;
        color: #7f8fa4;
      }
    }
  }
  .con{
    padding:20px 0;
    line-height: 28px;
  }
  .time{
    color:#999;
    text-align: right;
  }
  .submit{
    width:70%;
    padding-top: 40px;
    display: flex;
    display: -webkit-flex;
    .el-button{
      padding:12px 26px;
      margin-lefT:20px;
    }
  }
}
</style>